import React from 'react';
import I18n from 'i18n-js';
import staticRider from 'public/images/static-rider.svg';
import styles from './groupingTipsOnboarding.less';

const GroupingTipsOnboarding = () => (
  <div className={styles.groupingTipsOnboarding}>
    <img className={styles.rider} src={staticRider} alt="rider" />
    <div className={styles.title}>
      {I18n.t('shopify.orders.groupingTips.title')}
    </div>
    <div className={styles.text}>
      {I18n.t('shopify.orders.groupingTips.text')}
    </div>
  </div>
);

export default GroupingTipsOnboarding;
